import { render, staticRenderFns } from "./LocalizationChecker.vue?vue&type=template&id=24e3e06f&scoped=true&"
import script from "./LocalizationChecker.vue?vue&type=script&lang=js&"
export * from "./LocalizationChecker.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationChecker.vue?vue&type=style&index=0&id=24e3e06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3e06f",
  null
  
)

export default component.exports